export enum UserNotificationType {
    none,
    toast,
    dialog
}